import { memo } from "react";

import { Button } from "@components/Button";

type Props = {
  checkoutCtaText: string;
  handleCheckout: () => void;
};

const CartCheckoutViewBase = ({ checkoutCtaText, handleCheckout }: Props) => {
  return (
    <Button
      fluid
      id="checkout-button"
      mtrTrack={false}
      onClick={handleCheckout}
      type="primary-alt"
    >
      {checkoutCtaText}
    </Button>
  );
};

export const CartCheckoutView = memo(CartCheckoutViewBase);
